<template lang="pug">
v-container.thesis-tab(fluid)
  v-expansion-panels.thesis-panels(v-model='panel', variant='accordion')
    person-thesis-panel(
      v-for='(category, i) in Object.keys(categorizedTheses)',
      :key='i',
      :theses='categorizedTheses[category]',
      :title='translations[category]',
      :icon='icon[category]',
      :showSupervisor='showSupervisor',
      :showTutor='showTutor',
      :showStudent='showStudent',
      :descriptionOpenByDefault='descriptionOpenByDefault',
      :personContext='personContext'
    )
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { THESIS_STATUSES } from '~/constants/domain'
import type { PersonInterface } from '~/interfaces/person'
import type { Thesis } from '~/models/thesis'

defineOptions({
  name: 'PersonThesisTab',
})

const props = defineProps({
  personContext: {
    type: Object as () => PersonInterface,
    default: () => ({}),
  },
  theses: {
    type: Array as () => Array<Thesis>,
    required: true,
  },
  showSupervisor: {
    type: Boolean,
    default: true,
  },
  showTutor: {
    type: Boolean,
    default: true,
  },
  showStudent: {
    type: Boolean,
    default: true,
  },
  descriptionOpenByDefault: {
    type: Boolean,
    default: true,
  },
})

const panel = ref(0)
const icon = {
  available: 'mdi-calendar-check',
  assigned: 'mdi-calendar-clock',
  finished: 'mdi-calendar-check-outline',
}
const assignedStatuses = [THESIS_STATUSES[2], THESIS_STATUSES[1]]
const { t } = useI18n()

const categorizedTheses = computed(() => {
  return {
    available: props.theses.filter((t) => t.status === THESIS_STATUSES[0]),
    assigned: props.theses.filter((t) =>
      assignedStatuses.some((status) => status === t.status),
    ),
    finished: props.theses.filter((t) => t.status === THESIS_STATUSES[3]),
  }
})

const translations = computed(() => ({
  available: t('thesisStatus.available'),
  assigned: t('thesisStatus.assigned'),
  finished: t('thesisStatus.finished'),
}))
</script>

<style scoped>
.thesis-tab {
  padding: 0;
  width: 100%;
}

.thesis-panels {
  display: block;
  width: 100%;
}
</style>
